"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var lodash_1 = require("lodash");
var react_2 = require("react");
var icons_1 = require("../../../icons");
var layout_1 = require("../../layout");
var styles_1 = require("./styles");
var iconProps = {
    size: 16,
};
var MARGIN = 24;
var TreeView = function (_a) {
    var items = _a.items, _b = _a.selectable, selectable = _b === void 0 ? false : _b, selectedKey = _a.selectedKey, onSelect = _a.onSelect, _c = _a.expandedKeys, expandedKeys = _c === void 0 ? [] : _c, onExpandCollapse = _a.onExpandCollapse;
    var renderNode = react_2.useCallback(function (node, level) {
        if (level === void 0) { level = 0; }
        var children = node.children, title = node.title, key = node.key, _a = node.disabled, disabled = _a === void 0 ? false : _a;
        var selected = selectedKey === key;
        var hasChildren = lodash_1.isEmpty(children);
        var isExpanded = expandedKeys.includes(key);
        var paddingLeft = 8 + MARGIN * level;
        return (react_1.jsx(react_2.Fragment, { key: node.key },
            react_1.jsx("button", { disabled: disabled, onClick: function () {
                    var newKeys = lodash_1.xor(expandedKeys, [key]);
                    onExpandCollapse(newKeys);
                    if (selectable) {
                        onSelect === null || onSelect === void 0 ? void 0 : onSelect(key);
                    }
                }, css: react_1.css([styles_1.TreeViewStyles.treeNode, selected ? styles_1.TreeViewStyles.selected : undefined, { paddingLeft: paddingLeft }]) },
                react_1.jsx(icons_1.ChevronRight, __assign({}, iconProps, { css: react_1.css([
                        styles_1.TreeViewStyles.chevron,
                        {
                            visibility: !hasChildren ? 'visible' : 'hidden',
                            transform: "rotate(" + (isExpanded ? '90' : 0) + "deg)",
                        },
                    ]) })),
                react_1.jsx("span", { css: styles_1.TreeViewStyles.title }, title)),
            isExpanded && (children === null || children === void 0 ? void 0 : children.map(function (child) { return renderNode(child, level + 1); }))));
    }, [expandedKeys, onExpandCollapse, onSelect, selectable, selectedKey]);
    return (react_1.jsx(react_2.Fragment, null,
        react_1.jsx(react_1.Global, { styles: styles_1.TreeViewStyles }),
        react_1.jsx(layout_1.Flex, { direction: "column", gap: 4 }, items.map(function (item) { return renderNode(item, 0); }))));
};
exports.default = TreeView;
